import React from "react";
import "antd/dist/antd.dark.css";
import { Tabs } from "antd";
import DeviceCardView from "./DeviceCardView";

const AdminPage = () => {
  const tabKeys = {
    DeviceID: "DeviceID",
  };

  const tabItems = [
    {
      key: tabKeys.DeviceID,
      label: "Edge Device Registration",
      children: <DeviceCardView />,
    },
  ];

  const handleTabChange = (key) => {
    if (key === tabKeys.DeviceID) {
      setActiveTab("1");
    }
  };

  return (
    <div className="h-100 d-flex flex-column">
      <div className="flex-fill overflow-auto">
        <Tabs
          className="custom-tab h-100"
          defaultActiveKey={tabKeys.DeviceID}
          items={tabItems}
          destroyInactiveTabPane={true}
          onChange={handleTabChange}
        />
      </div>
    </div>
  );
};

export default AdminPage;
